import React, { ComponentProps } from 'react'

import { connect } from 'react-redux'
import Dropdown from 'components/Luxkit/Dropdown'
import { getSupportContact } from 'selectors/supportContactSelector'
import ListItem from 'components/Luxkit/List/ListItem'
import DropdownContainer from 'components/Luxkit/Dropdown/DropdownContainer'
import Flag from 'components/Luxkit/Flag'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import config from 'constants/config'
import shouldRenderWhatsApp from 'lib/whatsApp'
import { getSVGImageUrl } from 'lib/imageUtils'
import shouldRenderTimely from 'lib/timely'

import whatsAppIcon from '../../icons/whatsapp.svg'

interface Props extends ComponentProps<typeof Dropdown> {
  currentContact: App.GeoContacts;
  currentRegionCode: string;
  currentRegionName: string;
  isOpen: boolean;
  onPhoneToggle: () => void;
}

function NavigationHeaderDropdown({
  currentContact,
  currentRegionCode,
  currentRegionName,
  isOpen,
  triggerRef,
  onPhoneToggle,
  alignment,
}: Props) {
  const localContact = currentContact.local as App.GeoContact
  const internationalContact = currentContact.international as App.GeoContact

  const showTimelyPopup = (e) => {
    e.preventDefault()

    onPhoneToggle()

    window.open(config.TIMELY_LINK, 'popup', 'width=600,fullscreen=no,location=no,menubar=no,toolbar=no')
  }

  return (
    <Dropdown
      open={isOpen}
      onClose={onPhoneToggle}
      triggerRef={triggerRef}
      caretType="none"
      alignment={alignment}
    >
      <DropdownContainer
        fit="dropdown-items"
      >
        <ListItem
          size="small"
          aria-label={`${'Sales & Support contact'} - ${currentRegionName}`}
          href={`tel:${localContact.number}`}
          startIcon={<Flag countryCode={currentRegionCode} />}
          title="Sales & Support"
          onClick={onPhoneToggle}
          rel="nofollow"
          subtitle={localContact.humanReadable}
        />
        <ListItem
          size="small"
          startIcon={config.BRAND === 'luxuryescapes' ?
            <img src={getSVGImageUrl('logo-LE')} width="24" height="24" alt="support"/> :
            <LinePhoneIcon />}
          aria-label="International Support Centre contact"
          href={`tel:${internationalContact.number}`}
          title="International Support Centre"
          onClick={onPhoneToggle}
          rel="nofollow"
          subtitle={internationalContact.humanReadable}
        />
        {shouldRenderWhatsApp(currentRegionCode) &&
          <ListItem
            size="small"
            title="WhatsApp"
            aria-label={`WhatsApp - ${currentRegionName}`}
            startIcon={<img src={whatsAppIcon} width="24" height="24" alt="WhatsApp"/>}
            onClick={onPhoneToggle}
            href={`https://wa.me/${config.WHATS_APP_NUMBER}`}
            target="_blank"
            rel="noopener"
          />
        }
        {shouldRenderTimely(currentRegionCode) &&
          <ListItem
            size="small"
            title="Book store appointment"
            aria-label={`Timely - ${currentRegionName}`}
            startIcon={<img src={getSVGImageUrl('logo-LE')} width="24" height="24" alt="support"/>}
            onClick={showTimelyPopup}
            href={config.TIMELY_LINK}
            target="popup"
            rel="noopener"
          />
        }
      </DropdownContainer>
    </Dropdown>
  )
}

const mapStateToProps = (state: App.State) => ({
  currentContact: getSupportContact(state),
  currentRegionCode: state.geo.currentRegionCode,
  currentRegionName: state.geo.currentRegionName,
})

export default connect(mapStateToProps)(NavigationHeaderDropdown)
